export default __webpack_public_path__ + "7163352ebbe7f6d57798b8c7da34d6df.jpg";